import { render, staticRenderFns } from "./MonthlyPurchases.vue?vue&type=template&id=6e647fc2&scoped=true"
import script from "./MonthlyPurchases.vue?vue&type=script&lang=js"
export * from "./MonthlyPurchases.vue?vue&type=script&lang=js"
import style0 from "./MonthlyPurchases.vue?vue&type=style&index=0&id=6e647fc2&prod&lang=css"
import style1 from "./MonthlyPurchases.vue?vue&type=style&index=1&id=6e647fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e647fc2",
  null
  
)

export default component.exports